import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'groupSearch',
    standalone: false
})
export class GroupSearchPipe implements PipeTransform {
  transform(resources: any[], searchText: string, advancedSearch: Array<any> = []): any[] {
    // check if search is undefied
    if (resources && resources.length) {

        return resources.filter(groupData => {
            // initial search
            if (searchText) {
                // console.log("pipe get initial search is " + searchText);
                if (searchText && groupData.GROUP_NAME.toLowerCase().indexOf(searchText.toLowerCase()) === -1
                    && groupData.GROUP_NUMBER.toLowerCase().indexOf(searchText.toLowerCase()) === -1
                    && groupData.TAX_ID_EIN.toLowerCase().indexOf(searchText.toLowerCase()) === -1) {
                    return false;
                }

            } else {
                // advanced search
                if (advancedSearch[0] && groupData.GROUP_NAME.toLowerCase().indexOf(advancedSearch[0].toLowerCase()) === -1) {
                    return false;
                }
                if (advancedSearch[1] && groupData.GROUP_NUMBER.toLowerCase().indexOf(advancedSearch[1].toLowerCase()) === -1) {
                    return false;
                }
                if (advancedSearch[2] && groupData.TAX_ID_EIN.toLowerCase().indexOf(advancedSearch[2].toLowerCase()) === -1) {
                    return false;
                }
                if (advancedSearch[3] && groupData.CORP_ID.toLowerCase().indexOf(advancedSearch[3].toLowerCase()) === -1) {
                    return false;
                }
                if (advancedSearch[4] && groupData.COUNTY.toLowerCase().indexOf(advancedSearch[4].toLowerCase()) === -1) {
                    return false;
                }
                if (advancedSearch[5] && groupData.MARKET_SEGMENT.toLowerCase().indexOf(advancedSearch[5].toLowerCase()) === -1) {
                    if (advancedSearch[5] === 'all') { return false; }
                }
                if (advancedSearch[6] && groupData.BUSINESS_TYPE.toLowerCase().indexOf(advancedSearch[6].toLowerCase()) === -1) {

                    if (advancedSearch[6] === 'all') { return false; }
                }
                if (advancedSearch[7] && groupData.GROUP_STATUS.toLowerCase().indexOf(advancedSearch[7].toLowerCase()) === -1) {

                    if (advancedSearch[7] !== 'all') { return false; }
                }
                if (advancedSearch[8] === 'effectiveDate') {

                    if (advancedSearch[9] && groupData.EFFECTIVE_DATE.toLowerCase().indexOf(advancedSearch[9].toLowerCase()) === -1) {
                        return false;
                    }

                } else if (advancedSearch[8] === 'termDate') {

                    if (advancedSearch[9] && groupData.TERM_DATE.toLowerCase().indexOf(advancedSearch[9].toLowerCase()) === -1) {
                        return false;
                    }

                } else if (advancedSearch[8] === 'renewalDate') {

                    if (advancedSearch[9]
                        && groupData.RENEWAL_EFFECTIVE_DATE.toLowerCase().indexOf(advancedSearch[9].toLowerCase()) === -1) {
                        return false;
                    }
                }
                if (advancedSearch[10] && groupData.GENERAL_AGENCY.toLowerCase().indexOf(advancedSearch[10].toLowerCase()) === -1) {
                    return false;
                }
                if (advancedSearch[11] && groupData.ACCOUNT_MANAGER.toLowerCase().indexOf(advancedSearch[11].toLowerCase()) === -1) {
                    return false;
                }
                if (advancedSearch[12] && groupData.SALES_REPRESENTATIVE.toLowerCase().indexOf(advancedSearch[12].toLowerCase()) === -1) {

                    return false;
                }
                if (advancedSearch[13] && groupData.SALES_SUPPORT.toLowerCase().indexOf(advancedSearch[13].toLowerCase()) === -1) {
                    return false;
                }
                if (advancedSearch[14] && groupData.AGENT_NAME.toLowerCase().indexOf(advancedSearch[14].toLowerCase()) === -1) {
                    return false;
                }
                if (advancedSearch[15] && groupData.GROUP_ADMIN.toLowerCase().indexOf(advancedSearch[15].toLowerCase()) === -1) {
                    return false;
                }

            }

            return true;
        });
    } else {
        return resources;
    }

    // if (!resources) return [];
    // if (!searchText) return resources;
    // searchText = searchText.toLowerCase();

    // return resources.filter(groupData => {

    //    return groupData.GROUP_NAME.toLowerCase().includes(searchText.toLowerCase());

    // });
}

}
